import React from 'react';
import each from 'lodash/each';
import { Checkbox } from 'containers/form';

/**
 * Aggregations config for all entities
 * Fields:
 * * name - Human name of aggregator
 * * infoUrl - data provider for get an extended aggregation info
 * * field - field in result aggregation (backend config param)
 * * type - type of aggregation (for endpoint generation)
 * * endpointUniq - Endpoint uniqualization field,
 *    that needed for resolve conflict with geo-toponyms landings
 * * queryParam - search criteria in landing data provider
 * * isArray - is search criteria in landing data provider waits an array
 */

const localityAggregator = {
  name: 'Область/Район/Нас.Пункт',
  infoUrl: { url: 'landing/location-info', query: { withParent: true } },
  field: 'locality',
  type: 'location',
  endpointUniq: 'locality',
  removeQueryParams: ['landmarksDistance', 'subwaysDistance'],
  argEditor: (onChange, value) =>
    <Checkbox value={value} onChange={onChange} schema={{ label: 'Только нас. пункты' }} />
};

const removeQueryParams = ['landmarksDistance', 'subwaysDistance'];
const standartTopoAggs = {
  // Locality aggregation
  aggLocality: localityAggregator,
  // Districts aggregation
  aggDistricts: {
    name: 'Районы нас. пункта',
    infoUrl: { url: 'landing/location-info' },
    field: 'districts',
    type: 'location',
    isArray: true,
    removeQueryParams
  },
  // Toponyms aggregation
  aggToponyms: {
    name: 'Массивы',
    infoUrl: { url: 'landing/location-info' },
    field: 'toponyms',
    type: 'location',
    isArray: true,
    queryParam: 'districts',
    removeQueryParams
  },
  // OPC aggregation
  aggOpc: {
    name: 'ОПЦ (работает странно)',
    infoUrl: { url: 'landing/location-info' },
    field: 'opc',
    type: 'location',
    isArray: true,
    queryParam: 'opc',
    removeQueryParams
  },
  // Landmarks aggregation
  aggLandmarks: {
    name: 'Ориентиры',
    infoUrl: { url: 'landing/location-info' },
    field: 'landmarks',
    type: 'location',
    isArray: true,
    queryParam: 'landmarks',
    removeQueryParams
  },
  // Subways aggregation
  aggSubways: {
    name: 'Станции метро',
    infoUrl: { url: 'landing/location-info' },
    type: 'location',
    field: 'subways',
    isArray: true,
    queryParam: 'subways',
    removeQueryParams
  },
  // Streets (by toponym) aggregation - useful for living complexes
  aggStreetsToponym: {
    name: 'Улицы (Топоним.)',
    infoUrl: { url: 'landing/location-info' },
    type: 'location',
    field: 'streets_toponym',
    isArray: true,
    queryParam: 'streetsToponym',
    removeQueryParams
  },
};

const config = {
  newbuilds: {
    aggregations: {
      ...standartTopoAggs,
      // Object Classes aggregation
      aggObjectClasses: {
        name: 'Классификатор объектов',
        field: 'object_class',
        type: 'object_class',
        isArray: true,
        queryParam: 'objectClasses',
        infoUrl: { url: 'landing/newbuild-object-search' },
        removeQueryParams
      }
    }
  },
  addresses: {
    aggregations: {
      ...standartTopoAggs,
      // Streets by tree aggregation
      aggStreets: {
        name: 'Улицы (Дерево)',
        infoUrl: { url: 'landing/location-info' },
        type: 'location',
        field: 'streets',
        isArray: true,
        queryParam: 'streets',
        removeQueryParams
      },
    }
  },
  users: {
    aggregations: {
      // Locality aggregation
      aggLocality: localityAggregator,
      aggRubric: {
        name: 'Рубрика',
        field: 'rubric',
        type: 'rubric',
        isArray: true,
        queryParam: 'rubrics',
      }
    }
  },
  objects: {
    aggregations: {
      ...standartTopoAggs,
      // Object Classes aggregation
      aggType: {
        name: 'Тип',
        field: 'type',
        type: 'type',
        isArray: false,
        queryParam: 'type',
        // infoUrl: { url: 'landing/newbuild-object-search' },
        removeQueryParams
      }
    }
  }
};

const aggInfoUrls = {};
each(config, (aggEntity, eKey) => {
  aggInfoUrls[eKey] = {};
  each(aggEntity.aggregations, agg =>
    aggInfoUrls[eKey][agg.field] = agg.infoUrl
  );
});

export {
  config as default,
  aggInfoUrls
};
